import React, { useContext, useEffect, useState } from "react";
import { splitDate } from "../../../utils/splitDate";
import { CalendarIconSvg, MoonIconSvg, OneWayTripIconSvg, RoundTripIconSvg, ShipIconSvg } from "../../../assets/svg";
import { getQuotaionDetailById, regenerateQuotation } from "../../../api/quotation.api";
import CabinCard from "./CabinCard/CabinCard";
import PriceDetail from "../../../pages/AddLeads/stepThree/Components/PriceDetail";
import CustomButton from "../../CustomButton/CustomButton";
import DiscountSection from "./DiscountSection/DiscountSection";
import SsrSection from "./SsrSection/SsrSection";
import SnackbarContext from "../../../context/snackbar.context";
import dayjs from "dayjs";
import "./style.scss";

interface ViewDetailsModalProp {
  quotationDetail: any;
}

export interface ISsrData {
  quotationItemId: string;
  specialRequestId: string;
  price: number;
  status: string;
  name: string;
  specialRequest?: any;
}

const ViewDetailsModal: React.FC<ViewDetailsModalProp> = ({ quotationDetail }) => {
  const snackbarCtx = useContext(SnackbarContext);
  const [data, setData] = useState<any>({});
  const [ssrData, setSsrData] = useState<ISsrData[]>([]);
  const [price, setPrice] = useState<any>({ total: 0, cabin_names: [], cabin_fares: [], ssr_names: [], ssr_fares: [], service_tax_and_levies: 0, gst: 0, discount_category: {}, discount: 0, port_charges: 0, gratuity: 0, fuel_surcharge: 0 });
  const [tempDiscountObj, setTempDiscountObj] = useState({ tempQuotationStatus: '', tempQuotationDiscount: 0 });
  const [tabSwitch, setTabSwitch] = useState<1 | 2 | 3>(1);

  useEffect(() => {
    if (quotationDetail) {
      fetchData(quotationDetail)
    }
  }, [quotationDetail])

  const fetchData = async (quotationDetail: string) => {
    const response = await getQuotaionDetailById(quotationDetail);
    if (response.status === 200) {
      const flattenedSsrData = response?.result?.quotation?.items?.flatMap((item: any) => item?.specialRequests?.map((req: ISsrData) => ({ quotationItemId: req?.quotationItemId, specialRequestId: req?.specialRequestId, price: req?.price, status: req?.status, name: req?.specialRequest?.name })));
      setSsrData(flattenedSsrData);
      let tempObj: any = { total: 0, cabin_names: [], cabin_fares: [], ssr_names: [], ssr_fares: [], service_tax_and_levies: 0, gst: 0, discount: 0, discount_category: '', port_charges: 0, gratuity: 0, fuel_surcharge: 0 };
      response?.result?.pricing?.forEach((value: any) => {
        const discountCategoryObject = value?.discount_category?.reduce((acc: any, discountName: string) => {
          acc[discountName] = true;
          return acc;
        }, {});
        if (value.type === 'CABIN') {
          tempObj = {
            ...tempObj,
            total: tempObj.total + value.cabin_fare + value.service_tax_and_levies + value.gst + value.fuel_surcharge,
            cabin_names: [...tempObj.cabin_names, value.title],
            cabin_fares: [...tempObj.cabin_fares, value.cabin_fare],
            service_tax_and_levies: tempObj.service_tax_and_levies + value.service_tax_and_levies,
            gst: tempObj.gst + value.gst,
            discount_category: { ...tempObj.discount_category, ...discountCategoryObject },
            discount: tempObj.discount + value.discount,
            port_charges: tempObj.port_charges + value.port_charges,
            gratuity: tempObj.gratuity + value.gratuity,
            fuel_surcharge: tempObj.fuel_surcharge + value.fuel_surcharge,
          };
        } else {
          tempObj = {
            ...tempObj,
            total: tempObj.total + value.total + value.service_tax_and_levies + value.gst + value.fuel_surcharge,
            ssr_names: [...tempObj.ssr_names, value.title],
            ssr_fares: [...tempObj.ssr_fares, value.total],
            service_tax_and_levies: tempObj.service_tax_and_levies + value.service_tax_and_levies,
            gst: tempObj.gst + value.gst,
            discount_category: { ...tempObj.discount_category, ...discountCategoryObject },
            discount: tempObj.discount + value.discount,
            port_charges: tempObj.port_charges + value.port_charges,
            gratuity: tempObj.gratuity + value.gratuity,
            fuel_surcharge: tempObj.fuel_surcharge + value.fuel_surcharge
          };
        }
      });
      setPrice({ ...tempObj })
      setData(response.result)
    }
  }

  const regenerateQuotations = async ( quotationId:string, special_pricing?:boolean ) => {
    const response = await regenerateQuotation({ quotationId, special_pricing })
    if (response.status === 201) {
      fetchData(response?.result?.id);
      snackbarCtx.toggleSnackbar({
        message: "Quotation regenerated successfully",
        type: "SUCCESS",
        visible: true,
      });
    } else {
      snackbarCtx.toggleSnackbar({
        message: response?.response?.data?.message || "Something went wrong",
        type: "FAILURE",
        visible: true,
      });
    }
  }

  const handleTripType = (tripType: string) => {
    return tripType?.includes('one') ? 'One Way Trip' : 'Round Trip';
  }

  return (
    <div className="view-itinerary-modal-wrapper flex flex-col gap-3">
      <div className="flex gap-4 items-center">
        <span className="heading-text text-uppercase">Quotation Details</span>
        <span className="text-lg text-[#92278f]">{`[${data?.quotation?.number}]`}</span>
       {(data?.quotation?.status === "EXPIRED" || data?.quotation?.status === "REJECTED" ) && <CustomButton
        clx="self-end"
        onButtonClick={()=>regenerateQuotations(quotationDetail, false)}
      >
        Regenerate Quotation
      </CustomButton>}
      </div>
      <div className="guest-details-wrapper flex gap-20">
        <div className="flex flex-col gap-2">
          <span className="detail-name">Guest Name</span>
          <span>
            {data?.quotation?.customer?.firstName} {data?.quotation?.customer?.lastName}
          </span>
        </div>
        <div className="flex flex-col gap-2">
          <span className="detail-name">Contact</span>
          <span>{data?.quotation?.customer?.phoneNumber}</span>
        </div>
        <div className="flex flex-col gap-2">
          <span className="detail-name">Whatsapp</span>
          <span>{data?.quotation?.customer?.whatsappNumber}</span>
        </div>
        <div className="flex flex-col gap-2">
          <span className="detail-name">Email</span>
          <span>{data?.quotation?.customer?.email}</span>
        </div>
      </div>
      <section className="flex flex-col gap-2.5 itinerary-details-wrapper">
        <p>{data?.itinerary?.route}</p>
        <div className="itinerary-duration flex gap-5">
          <div className="flex items-center gap-2.5">
            <CalendarIconSvg height={20} width={20} fill="#7a7a7a" />
            <span>
              {dayjs(splitDate(data?.itinerary?.start_time)).format("DD MMM YYYY")} -{" "}
              {dayjs(splitDate(data?.itinerary?.end_time)).format("DD MMM YYYY")}
            </span>
          </div>
          <div className="flex items-center gap-2">
            {data?.itinerary?.trip_type?.includes("one") ? (
              <OneWayTripIconSvg height={16} width={16} />
            ) : (
              <RoundTripIconSvg height={20} width={20} />
            )}
            <span className="trip-type">{handleTripType(data?.itinerary?.trip_type)}</span>
          </div>
          <div className="flex items-center gap-2">
            <MoonIconSvg fill="#7a7a7a" height={18} width={18} />
            <span>{data?.itinerary?.night_count} Nights</span>
          </div>
          <div className="flex items-center gap-2">
            <ShipIconSvg fill="#7a7a7a" height={22} width={20} />
            <span className="text-capitalize">{data?.itinerary?.ship_name?.toLowerCase()}</span>
          </div>
        </div>
      </section>
      <div className="flex gap-2">
        <section className="tab-button-section-wrapper flex flex-col gap-2.5">
          <CustomButton fillColor={tabSwitch === 1} onButtonClick={() => setTabSwitch(1)}>
            Cabin Details
          </CustomButton>
          <CustomButton fillColor={tabSwitch === 2} onButtonClick={() => setTabSwitch(2)}>
            Price & Discounts
          </CustomButton>
          {/* {ssrData?.some(item => item.price > 0) && <CustomButton fillColor={tabSwitch === 3} onButtonClick={() => setTabSwitch(3)}>
            Special Services
          </CustomButton>} */}
        </section>
        {tabSwitch === 1 && (
          <section className="w-full h-full max-h-[40vh] rounded overflow-auto view-details-cards-wrapper">
            <div className="view-details-card-wrapper w-full p-3">
              <CabinCard cabinDetails={data?.quotation} />
            </div>
          </section>
        )}
        {tabSwitch === 2 && <div className="flex w-full h-full gap-2 max-h-[40vh] overflow-auto">
          <PriceDetail show={true} viewDetail={true} netPrice={price} clx={"w-full"} discountDescription={data?.quotation?.offerDescriptions} />          
          <DiscountSection
            quotationId={quotationDetail}
            quotationStatus={data?.quotation?.status}
            tempQuotationStatus={tempDiscountObj.tempQuotationStatus}
            quotationDiscount={data?.quotation?.discountRequest}
            tempQuotationDiscount={tempDiscountObj.tempQuotationDiscount}
            setTempDiscountObj={setTempDiscountObj}
            totalPrice={price?.total - price?.service_tax_and_levies}
          />
        </div>}
        {tabSwitch === 3 && ssrData?.some((item) => item.price > 0) && (
          <SsrSection quotationStatus={data?.quotation?.status} ssrData={ssrData} setSsrData={setSsrData} />
        )}
      </div>
    </div>
  );
};

export default ViewDetailsModal;
